import React from 'react'
import "./Heading.css";

export default function Heading({ headingText }) {
    return (
        <div className='reset-heading'>
            <h1>{headingText}</h1>
        </div>
    )
}
